import { defineMessages } from 'react-intl';

export const additionalDetailsStepMessages = defineMessages({
  shipmentServicesHeader: {
    defaultMessage: 'Shipment Services',
    id: 'SKUN41',
    description: 'Header for the shipment services checkboxes',
  },
  sortAndSegregate: {
    defaultMessage: 'Sort and Segregate',
    id: 'W9CEP8',
    description: 'Checkbox label for the sort and segregate shipment service',
  },
  protectFromFreeze: {
    defaultMessage: 'Protect from Freeze',
    id: 'IjO8bL',
    description: 'Checkbox label for the protect from freeze shipment service',
  },
  addHandlingCharge: {
    defaultMessage: 'Add a handling charge',
    id: 'DFtyae',
    description: 'Checkbox label to add a handling charge to the shipment',
  },
  handlingChargeLabel: {
    defaultMessage: 'Handling Charge',
    id: 'N66uBx',
    description: 'Label for the handling charge amount input',
  },
  addReferences: {
    defaultMessage: 'Add references',
    id: '65a5Si',
    description: 'Checkbox label to add reference numbers to the shipment',
  },
  referenceTypeLabel: {
    defaultMessage: 'Type',
    id: 'A4zJoJ',
    description: 'Label for a reference row type input',
  },
  referenceTypePlaceholder: {
    defaultMessage: 'e.g. PO Number',
    id: '2U6x9z',
    description: 'Placeholder for a reference row type input',
  },
  referenceValueLabel: {
    defaultMessage: 'Value',
    id: 'Syi0Lt',
    description: 'Label for a reference row value input',
  },
  referenceValuePlaceholder: {
    defaultMessage: 'Enter value',
    id: 'tS8v9q',
    description: 'Placeholder for a reference row value input',
  },
  removeReference: {
    defaultMessage: 'Remove',
    id: 'QgI9ck',
    description: 'Button to remove a reference row',
  },
  addReference: {
    defaultMessage: '+ Add reference',
    id: 't8/ooF',
    description: 'Button to add another reference row',
  },
  handlingInstructionsLabel: {
    defaultMessage: 'Handling Instructions (Optional)',
    id: '9i7a29',
    description: 'Label for the optional handling instructions textarea',
  },
  summaryPickup: {
    defaultMessage: 'Pickup: {ready} – {close}',
    id: 'qJqZ8Z',
    description: 'Summary of the pickup window times',
  },
  summaryHandlingCharge: {
    defaultMessage: 'Handling charge: {value, number, ::currency/USD}',
    id: '4RAaXQ',
    description: 'Summary of the handling charge amount',
  },
  summaryShipmentServicesLabel: {
    defaultMessage: 'Shipment Services',
    id: 'BR2jp+',
    description: 'Bold section label in the summary for selected shipment services',
  },
  summaryHandlingChargeLabel: {
    defaultMessage: 'Handling Charge',
    id: 'e/lN6X',
    description: 'Bold section label in the summary for the handling charge',
  },
  summaryReferencesLabel: {
    defaultMessage: 'References',
    id: 'tkr8el',
    description: 'Bold section label in the summary for added references',
  },
  summaryReferenceItem: {
    defaultMessage: '{type}: {value}',
    id: 'u/0O9G',
    description: 'A single reference line in the summary showing type and value',
  },
  summaryNotificationsLabel: {
    defaultMessage: 'Shipment Alerts',
    id: 'JIE2rQ',
    description: 'Bold section label in the summary for configured email notification recipients',
  },
});
